import { ViewTransitionLink } from '#app/components/view-transition-link.tsx'

export default function TestViewTransitions() {
	return (
		<div className="min-h-screen bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
			<div className="bg-white rounded-lg shadow-xl p-8 max-w-md">
				<h1 className="text-2xl font-bold mb-4">View Transitions Test</h1>
				<p className="mb-6 text-gray-600">
					Click the links below to see the expanding circle animation from bottom-right.
				</p>
				<div className="space-y-3">
					<ViewTransitionLink
						to="/"
						className="block w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-center"
					>
						Go to Home
					</ViewTransitionLink>
					<ViewTransitionLink
						to="/login"
						className="block w-full px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 text-center"
					>
						Go to Login
					</ViewTransitionLink>
					<ViewTransitionLink
						to="/cases"
						className="block w-full px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600 text-center"
					>
						Go to Cases
					</ViewTransitionLink>
				</div>
				<div className="mt-6 p-3 bg-gray-100 rounded text-sm text-gray-600">
					<p>✨ The animation should expand from bottom-right corner</p>
					<p className="mt-1">🔧 Check console for any errors</p>
					<p className="mt-1">🌐 Requires Chrome 111+, Edge 111+, or Opera 97+</p>
				</div>
			</div>
		</div>
	)
}